module.exports = __webpack_public_path__ + "img/attitute-of-gratitute.d1d53db7.png";